import styled from 'styled-components';
import colors from '../../../constants/colors';

const Wrapper = styled.div`
  outline: 1px solid ${colors.main.ruby};
`;

export default Wrapper;
